import { render, staticRenderFns } from "./ChangeEmailPage.vue?vue&type=template&id=68868da8&scoped=true"
import script from "./ChangeEmailPage.vue?vue&type=script&lang=ts"
export * from "./ChangeEmailPage.vue?vue&type=script&lang=ts"
import style0 from "./ChangeEmailPage.vue?vue&type=style&index=0&id=68868da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68868da8",
  null
  
)

export default component.exports